import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import ReportNotFoundOrAccessForbiddenPageIcon from "../../../../common/ReportNotFoundOrAccessForbiddenPageIcon";

const ReportNotFoundOrAccessForbidden = () => {
  const navigate = useNavigate();

  return (
    <Stack spacing={3} useFlexGap sx={{ alignItems: "center", justifyContent: "center", flex: 1 }}>
      <ReportNotFoundOrAccessForbiddenPageIcon sx={{ height: 74, width: 55 }} />
      <Typography variant="h6">The report was not found or you do not have access to it.</Typography>
      <Button variant="outlined" color="secondary" onClick={() => navigate(`..`)}>
        Close
      </Button>
    </Stack>
  );
};

export default ReportNotFoundOrAccessForbidden;
